module.exports = __webpack_public_path__ + "media/images/newborn_foal-ae3297500de4e863fd3e898de333e741.jpg";